import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { services } from "../utils/environments/api";

const Careers = () => {
  const [isVisible, setIsVisible] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  const handleOpenPopup = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    const centerX = window.innerWidth / 2;
    
    setPopupPosition({
      top: scrollY + 100, // Scroll position paina 100px gap
      left: centerX
    });
    setShowPopup(true);
  };

   const [formData, setFormData] = useState({
       name: "",
       email: "",
       number: "",
       expected_ctc: "",
       techos: "",
       location: "",
     });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);
  
    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true);
      setSuccess(null);
  
      try {
        const res = await fetch("https://vincosys.com/backend/api/post_profile_api.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        });
  
        if (res.ok) {
          setSuccess(true);
          setFormData({ name: "", email: "", message: "" });
          setTimeout(() => {
            setShowPopup(false);
            setSuccess(null);
          }, 2000);
        } else {
          setSuccess(false);
        }
      } catch (error) {
        console.error(error);
        setSuccess(false);
      } finally {
        setLoading(false);
      }
    };


    const [service, setService] = useState([]);
    
      useEffect(() => {
        serviceData();
      }, []);
    
      const serviceData = async () => {
        try {
          const res = await services.get("get_service_typ_api.php");
          if (res.data.data) {
            setService(res.data.data);
          } else {
            console.error("Invalid response format:", res);
          }
        } catch (error) {
          console.error("Error during API call:", error);
        }
      };

  const careerServices = [
    {
      id: 1,
      title: "IoT Services",
      skills: ["C", "C++", "Python", "+2"],
      description: "IoT services connect devices, collect data, and optimize operations for improved efficiency and insights.",
      link: "/ServiceIot",
      icon: (
        <div className="service-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"/>
            <circle cx="5" cy="12" r="2"/>
            <circle cx="19" cy="4" r="2"/>
            <circle cx="19" cy="20" r="2"/>
            <path d="M12 3h2v2h-2zM12 19h2v2h-2zM3 12h2v2H3zM19 12h2v2h-2z"/>
          </svg>
        </div>
      )
    },
   
    {
      id: 3,
      title: "Product Development",
      skills: ["Adobe", "Figma", "Python", "+2"],
      description: "Product development services encompass ideation, design, prototyping, testing, and market launch.",
      link: "/ProductDev",
      icon: (
        <div className="service-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
      )
    },
    {
      id: 4,
      title: "Web Design & Development",
      skills: ["HTML", "CSS", "JavaScript", "+2"],
      description: "Create responsive websites, enhance user experience and functionality with modern web technologies.",
      link: "/WebDev",
      icon: (
        <div className="service-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
          </svg>
        </div>
      )
    },
    {
      id: 5,
      title: "Mobile Application Development",
      skills: ["Swift", "Kotlin", "React Native", "+2"],
      description: "Design and maintain apps for iOS and Android, ensuring optimal user experience and performance.",
      link: "/MobileDev",
      icon: (
        <div className="service-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"/>
          </svg>
        </div>
      )
    },
    {
      id: 6,
      title: "Digital Marketing",
      skills: ["SEO", "SEM", "CMS", "+2"],
      description: "Enhance brand visibility through SEO, social media, content marketing, and targeted advertising.",
      link: "/DigitalMarketing",
      icon: (
        <div className="service-icon">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.78-1.18 2.73-3.12 3.16z"/>
          </svg>
        </div>
      )
    }
  ];

  const jobOpenings = [
    {
      id: 1,
      position: "Senior IoT Developer",
      department: "IoT Services",
      type: "Full-time",
      location: "Hyderabad",
      experience: "3-5 years",
      posted: "2 days ago"
    },
    {
      id: 2,
      position: "Frontend Developer",
      department: "Web Development",
      type: "Full-time",
      location: "Bangalore",
      experience: "2-4 years",
      posted: "1 week ago"
    },
    {
      id: 3,
      position: "Mobile App Developer",
      department: "Mobile Development",
      type: "Remote",
      location: "Anywhere",
      experience: "2-3 years",
      posted: "3 days ago"
    },
    {
      id: 4,
      position: "Digital Marketing Specialist",
      department: "Marketing",
      type: "Full-time",
      location: "Chennai",
      experience: "1-3 years",
      posted: "5 days ago"
    }
  ];

  return (
    <div className={`careers-page ${isVisible ? "visible" : ""}`}>
      {/* Hero Section */}
      <div class="page-title">
        <div
          class="pattern-layer-one"
          // style={{
          //   backgroundImage:
          //     "url(../../assets/Images/background/pattern-16.png)",
          // }}
        ></div>
        <div class="container">
          <h2>Careers</h2>
          <ul class="page-breadcrumb">
            <li>
              <Link to="/">home&gt;</Link>
            </li>
            <li>Careers</li>
          </ul>
        </div>
      </div>

      {/* Services Section */}
      <div className="services-section">
        <div className="container">
          <div className="section-header">
            <h2>Our Services</h2>
            <p>Explore opportunities in our diverse service domains</p>
          </div>
          <div className="services-grid">
            {careerServices.map((service) => (
              <div className="service-card" key={service.id}>
                <div className="">
                  {service.icon}
                  <h3>{service.title}</h3>
                </div>
                <div className="skills-list">
                  {service.skills.map((skill, index) => (
                    <span key={index} className="skill-tag">{skill}</span>
                  ))}
                </div>
                <p className="service-description">{service.description}</p>
                <Link to={service.link} className="service-link">
                  View Opportunities <i className="ri-arrow-right-s-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Current Openings */}
      <div className="openings-section">
        <div className="container">
          <div className="section-header">
            <h2>Current Job Openings</h2>
            <p>Join our talented team and grow with us</p>
          </div>
          <div className="jobs-grid">
            {jobOpenings.map((job) => (
              <div className="job-card" key={job.id}>
                <div className="job-header">
                  <h3>{job.position}</h3>
                  <span className="job-type">{job.type}</span>
                </div>
                <div className="job-details">
                  <div className="detail">
                    <i className="ri-building-line"></i>
                    <span>{job.department}</span>
                  </div>
                  <div className="detail">
                    <i className="ri-map-pin-line"></i>
                    <span>{job.location}</span>
                  </div>
                  <div className="detail">
                    <i className="ri-user-line"></i>
                    <span>{job.experience}</span>
                  </div>
                </div>
                <div className="job-footer">
                  <span className="posted-date">{job.posted}</span>
                  <button className="apply-btn"  
                onClick={handleOpenPopup}>Apply Now</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Why Join Us Section */}
      <div className="benefits-section mb-4">
        <div className="container">
          <div className="section-header">
            <h2>Why Join Our Team?</h2>
          </div>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="ri-team-line"></i>
              </div>
              <h4>Collaborative Environment</h4>
              <p>Work with talented professionals in a supportive team culture</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                {/* <i className="ri-growth-line"></i> */}
                <i class="ri-line-chart-line"></i>
              </div>
              <h4>Career Growth</h4>
              <p>Continuous learning opportunities and clear career progression paths</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="ri-flashlight-line"></i>
              </div>
              <h4>Innovative Projects</h4>
              <p>Work on cutting-edge technologies and challenging projects</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <i className="ri-global-line"></i>
              </div>
              <h4>Global Impact</h4>
              <p>Your work will reach clients and users across the globe</p>
            </div>
          </div>
        </div>
      </div>
       {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div 
            className="popup-content" 
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: `50%`,
              left: '50%',
              transform: 'translateX(-50%)'
            }}
          >
            <button
              onClick={() => setShowPopup(false)}
              className="popup-close"
            >
              ✖
            </button>

            <h3 className="popup-title">Apply Now</h3>
            <form onSubmit={handleSubmit} className="popup-form">
              <div className="form-group col-lg-6 col-md-6 col-sm-12">
          <label>Your name *</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            placeholder=""
            required
            onChange={handleChange}
            className="form-control"
          />
        
        </div>

        <div className="form-group col-lg-6 col-md-6 col-sm-12">
          <label>Email address *</label>
          <input
            type="text"
            name="email"
            value={formData.email}
            placeholder=""
            required
            onChange={handleChange}
            className="form-control"
          />
        
        </div>

        <div className="form-group col-lg-6 col-md-6 col-sm-12">
          <label>Phone number *</label>
          <input
            type="text"
            name="number"
            value={formData.number}
            placeholder=""
            required
            onChange={handleChange}
            className="form-control"
          />
        
        </div>
        <div className="form-group col-lg-6 col-md-6 col-sm-12">
          <label>Technologies *</label>
          <select name="techos" class="form-select" value={formData.techos} onChange={handleChange}>
            <option value="">Select Technology</option>
             {service.length > 0 ? (
          service.map((item) => (
            <option key={item.servicetype_id} value={item.service}>
              {item.service}
            </option>
          ))
        ) : (
          <option disabled>Loading services...</option>
        )}
          </select>
        </div>

        <div className="form-group col-lg-6 col-md-6 col-sm-12">
          <label>Expected CTC (Lakhs)*</label>
          <input
            type="text"
            name="expected_ctc"
            value={formData.expected_ctc}
            placeholder=""
            required
            onChange={handleChange}
            className="form-control"
          />
        
        </div>

        <div className="form-group col-lg-6 col-md-6 col-sm-12">
          <label>Location *</label>
          <input
            type="text"
            name="location"
            value={formData.location}
            placeholder=""
            required
            onChange={handleChange}
            className="form-control"
          />
        </div>

              <button
                type="submit"
                disabled={loading}
                className="submit-button"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>

            {success === true && (
              <p className="success-message">Message sent successfully!</p>
            )}
            {success === false && (
              <p className="error-message">Something went wrong. Please try again.</p>
            )}
          </div>
        </div>
      )}

      <style jsx>{`
        .popup-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 9;
        }

        .popup-content {
          background: white;
          border-radius: 16px;
          padding: 32px;
          width: 90%;
          max-width: 480px;
          position: fixed;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
          animation: slideDown 0.3s ease-out;
          margin-top: 20px;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        .popup-close {
          position: absolute;
          top: 7px;
          right: 10px;  
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
          color: #666;
          padding: 4px;
        }

        .popup-close:hover {
          color: #000;
        }

        .popup-title {
          font-size: 24px;
          font-weight: 600;
          margin-bottom: 24px;
          text-align: center;
          color: #1f2937;
        }

        .popup-form {
          display: flex;
          flex-direction: column;
          // gap: 16px;
        }

          .form-group{
          margin-bottom:10px;
          padding:0px;
          }

        .form-input:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
        }

        .submit-button {
          width: 100%;
          background: #2563eb;
          color: white;
          border: none;
          border-radius: 8px;
          padding: 12px 24px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }

        .submit-button:hover:not(:disabled) {
          background: #1d4ed8;
        }

        .submit-button:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .success-message {
          color: #059669;
          text-align: center;
          margin-top: 16px;
          font-size: 14px;
        }

        .error-message {
          color: #dc2626;
          text-align: center;
          margin-top: 16px;
          font-size: 14px;
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .popup-content {
            width: 95%;
            padding: 24px;
            margin-top: 10px;
          }
          
          .popup-title {
            font-size: 20px;
          }
        }
         
      `}</style>
    </div>
  );
};

export default Careers;